import { Fragment } from 'react'

import { SEARCH_SNIPPET_HIGHLIGHT_MARK_CLASS } from 'src/constants/searchHighlight'

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** Wraps case-insensitive matches of `query` in `<mark>` for universal search snippets. */
export const highlightSearchQueryInPlainText = (text: string, query: string) => {
  const trimmed = query.trim()
  if (!trimmed) {
    return text
  }
  try {
    const re = new RegExp(`(${escapeRegExp(trimmed)})`, 'gi')
    const parts = text.split(re)
    return parts.map((part, idx) =>
      part.toLowerCase() === trimmed.toLowerCase() ? (
        <mark key={idx} className={SEARCH_SNIPPET_HIGHLIGHT_MARK_CLASS}>
          {part}
        </mark>
      ) : (
        <Fragment key={idx}>{part}</Fragment>
      )
    )
  } catch {
    return text
  }
}
